import HomeIcon from "@mui/icons-material/Home";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import { Button, Typography } from "@mui/material";
import { UnauthenticatedLayout } from "Components/Layout/UnauthenticatedLayout";
import { UnstyledLink } from "Components/Routes/UnstyledLink";
import { Resources, useResource } from "Translations/Resources";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

const StyledPage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const StyledIcon = styled(NotInterestedIcon)`
  margin: 20px;
  font-size: 120px;
`;

export const Error404Page = () => {
  const { t } = useResource();
  const location = useLocation();

  return (
    <UnauthenticatedLayout title="404">
      <StyledPage>
        <Typography variant="h1">Error404</Typography>
        <Typography variant="h2">{location.pathname}</Typography>
        <Typography variant="h2">
          {t(Resources.Errors.Error404.Subtitle)}
        </Typography>
        <StyledIcon />
        <UnstyledLink to="/">
          <Button
            startIcon={<HomeIcon />}
            size="large"
            variant="contained"
            color="primary"
          >
            {t(Resources.Errors.Error404.Home)}
          </Button>
        </UnstyledLink>
      </StyledPage>
    </UnauthenticatedLayout>
  );
};

export default Error404Page;
